import { useContext } from "react";
import CheckUpContext from "../../context/check-up";
import useCheckUpCompleteMutation from "../../hooks/mutations/useCheckupCompleteMutation";
import SubmitRequestModal from "../submit-request-modal";

const CheckUpSubmitRequestModal = ({ show, closeModal, request }) => {
  const { labels, currentRequest, setNavigation } = useContext(CheckUpContext);

  const { mutateAsync: asyncSubmitRequest, isError } = useCheckUpCompleteMutation(closeModal);

  const submitObject = {
    submitRequest: async (request) => {
      await asyncSubmitRequest({ request });
    },
    isError,
  };

  const saveDraft = () => {
    closeModal();
    setNavigation();
  };

  return (
    <SubmitRequestModal
      show={!!show}
      closeModal={closeModal}
      labels={labels}
      saveDraft={saveDraft}
      submitObject={submitObject}
      request={request || currentRequest}
      additionalDescription={labels?.WELFARE_CHECKUP_SUBMIT_REQUEST_ADDITIONAL_TEXT}
    />
  );
};

export default CheckUpSubmitRequestModal;
